import { render, staticRenderFns } from "./Sonetpage.vue?vue&type=template&id=6bdc4cca&scoped=true"
import script from "./Sonetpage.vue?vue&type=script&lang=js"
export * from "./Sonetpage.vue?vue&type=script&lang=js"
import style0 from "./Sonetpage.vue?vue&type=style&index=0&id=6bdc4cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc4cca",
  null
  
)

export default component.exports